import { render, staticRenderFns } from "./AppContactsLinkRulesConfigure.vue?vue&type=template&id=1ed30d01&scoped=true"
import script from "./AppContactsLinkRulesConfigure.vue?vue&type=script&lang=js"
export * from "./AppContactsLinkRulesConfigure.vue?vue&type=script&lang=js"
import style0 from "./AppContactsLinkRulesConfigure.vue?vue&type=style&index=0&id=1ed30d01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed30d01",
  null
  
)

export default component.exports